// extracted by mini-css-extract-plugin
export default {"layout":"OffersManager_layout__TNATX","error":"OffersManager_error__gmC9Z","btn":"OffersManager_btn__vFjEe"};